/**
 * created by lei lei on 2020/5/29
 * 报送选题提醒
 */
import React, {Component} from 'react';
import ActivityTrends from './ActivityTrends';
import {formateData, headers} from "../../../../actions";
import {Empty, message} from "antd";
import {connect} from "react-redux";
import {timeago} from "../../../../utils";
import {
    shrinNavigateStauts,
    updateNavigateLevel2Data
} from "../../../../actions";
import moreImg from "../commImg/diandiandian.png";

class TopicSubmissionReminderComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    maxNum = 5;

    constructor(props) {
        super(props);
        this.state = {
            dataSourrce : [],
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    initData()
    {
        getMyRemindByType(3, (data)=>{
            if(data && data.data)
            {
                let list = data.data;
                let dataSourrce = [];
                {list.map((item, i)=>
                {
                    if(i < this.maxNum)
                    {
                        dataSourrce.push(item);
                    }
                })}
                this.setState({
                    dataSourrce : dataSourrce
                })
            }
        });
    }

    findUrlData = (url)=>{
        let sons;
        let name;
        let stopFind = false;

        let find = (data, level, levelOneBrothers, levelOneName) => {
            if(stopFind)
                return;
            if((!data.sons || data.sons.length===0) && (!data.float_ || data.float_.length===0)){
                if(data.path === url){
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if(!tempSons || tempSons.length === 0){
                tempSons = data.sons;
            }
            if(stopFind)
                return;
            tempSons && tempSons.map(item => {
                if(stopFind)
                    return;
                let tempItemSons = item.float_;
                if(!tempItemSons || tempItemSons.length === 0){
                    tempItemSons = item.sons;
                }
                if(level == 0){//取第一级的信息
                    find(item, level+1, tempItemSons, item.name);
                }else{
                    find(item, level+1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons:this.props.navigateData},0, null, null);
        return {stopFind, sons, name};
    }

    gotoPage = (url)=>{
        let {stopFind, sons, name} = this.findUrlData(url);
        if(stopFind){
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            window.location.hash = url;
            return;
        }
        message.error("暂无权限！");
    }

    render() {
        let url = "/topicSelectManager/topicSelectManager";
        let {stopFind} = this.findUrlData(url);
        /*if(!stopFind){
            return <div></div>
        }*/
        return (
            <div className={'ActivityTrendsComponents StaticMyDeskItemPaddingTop'} style={{width:'100%'}}>
                <div style={{background:'#FFFFFF',}}>
                  <div style={{height:56,lineHeight:'56px',background:'white',width: '100%',float:'left',borderBottom:'1px solid #ebebeb'}}>
                        <div style={{fontSize:14,paddingLeft:20,float:'left',color:'#333333'}}>
                            报送选题提醒</div>
                        <div onClick={()=>{
                            //window.location.hash = "/topicSelectManager/topicSelectManager";
                            this.gotoPage(url);
                        }} style={{fontSize:13,right:0,color:'#0050B3',float:'right',marginRight:20,cursor: 'pointer',marginTop:2}}>
                            <img src={moreImg} alt=""/>
                        </div>
                    </div>
                    <div style={{clear:'both'}}/>
                    <div style={{height:500}}>
                    {this.state.dataSourrce.length===0?<div style={{paddingTop:180}}><Empty/></div>:this.state.dataSourrce.map((item,i)=>{
                        return(
                            <ActivityTrends key={i}
                                dataSourrce={item.message}
                                statusMark={item._status}
                                timeMark={timeago(item.creatDate.time)}
                                showStatus={true}
                                onClickItem={(data)=>{
                                    this.showClickDialog(data);
                                }}
                            />
                        )
                    })}
                    </div>
                </div>

            </div>
        )
    }

    showClickDialog(obj)
    {
        if(obj && obj.length >= 2)
        {
            if(obj[0] === "interview")
            {
                showInterview(obj[1], "");
            }
            if(obj[0] === "news")
            {
                showNews(obj[1], "");
            }
        }
    }

}

function mapStateToProps(state){
    return {
        navigateData: state.systemReducer.navigateData,
        navigateStatus:state.systemReducer.navigateStatus,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(TopicSubmissionReminderComponents);

export const getMyRemindByType = (type, callBack)=> {
    let url = "/cm-sites-pms/remind/getMyRemindByType";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({type})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyRemindByType",error);
        callBack("");
    })
}

function showInterview(interviewId, title)
{
    window.layer.open({
        id: "",
        //btn: ['确定', '关闭'],
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId,
        title : title,
        resize : true,
        shade : 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex : 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px',parseInt(window.$(window).height() * 0.9) + 'px'],
        yes : function(index, layero) {

        },
        end: function () {
        }
    })
}

function showNews(newsId, title)
{
    window.layer.open({
        id: "",
        //btn: ['确定', '关闭'],
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/topicSelectManager/cluesubmit.html?id=" + newsId,
        title : title,
        resize : true,
        shade : 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex : 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px',parseInt(window.$(window).height() * 0.9) + 'px'],
        yes : function(index, layero) {

        },
        end: function () {
        }
    })
}